// V-4 — Las opciones de un desplegable de «Entrenador».
//
// Un solo sitio porque son SEIS desplegables (uno en Grupos, cinco en Sesiones:
// el filtro, la clase especial, editar el entrenador de una sesión, mover y
// duplicar). Copiado seis veces, el día que cambie el criterio cambiaría en
// cinco.
//
// No pinta el «Sin asignar» ni el «Todos»: cada sitio tiene su propio hueco y su
// propia palabra para eso, y no son la misma.

import { agrupaEntrenadores, type EntrenadorAsignable } from '../lib/entrenadoresAsignables';

export function OpcionesDeEntrenador({ lista }: { lista: readonly EntrenadorAsignable[] }) {
  const { deEquipo, deDireccion } = agrupaEntrenadores(lista);

  // Sin nadie de dirección, la lista de siempre y sin rótulos: un `optgroup`
  // único es un encabezado que no separa de nada.
  if (deDireccion.length === 0) {
    return (
      <>
        {deEquipo.map((p) => (
          <option key={p.id} value={p.id}>
            {p.full_name}
          </option>
        ))}
      </>
    );
  }

  return (
    <>
      {deEquipo.length > 0 && (
        <optgroup label="Entrenadores">
          {deEquipo.map((p) => (
            <option key={p.id} value={p.id}>
              {p.full_name}
            </option>
          ))}
        </optgroup>
      )}
      <optgroup label="Dirección">
        {deDireccion.map((p) => (
          <option key={p.id} value={p.id}>
            {p.full_name}
          </option>
        ))}
      </optgroup>
    </>
  );
}
